// extracted by mini-css-extract-plugin
module.exports = {"icon":"verificacion_icon__2bgob"};